import TIML from '../../../framework/timl.js';
import { AppConfig } from '../../config.js';
import { ShowPage } from '../crud/shared.js';
import { AuthShow } from '../auth_configs/show.js';

export class AdminDetails {
  static timl = `
    section.auth-overview-card
      .auth-overview-summary
        .auth-overview-thumbnail.admin-overview-thumbnail
          span.admin-overview-person[aria-hidden="true"]
        .auth-overview-identity
          .auth-overview-title-row
            h3 {{ item.email }}
            span[class="auth-status-badge {{ item.statusClass }}"] {{ item.status }}
          .auth-overview-domain-row
            span.auth-overview-domain.admin-overview-role {{ item.role }} administrator
      .auth-overview-stats
        .auth-overview-stat
          span.auth-overview-stat-icon.auth-overview-stat-users[aria-hidden="true"]
          strong {{ item.role }}
          span Role
        .auth-overview-stat
          span.auth-overview-stat-icon.auth-overview-stat-calendar[aria-hidden="true"]
          strong {{ item.createdDate }}
          span Created
        .auth-overview-stat
          span.auth-overview-stat-icon.auth-overview-stat-status[aria-hidden="true"]
          strong {{ item.verificationStatus }}
          span Email Status

    section.auth-details-card
      h2 Details
      .auth-details-grid
        .auth-detail-column
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-id[aria-hidden="true"] #
            span.auth-detail-label ID
            span.auth-detail-value {{ item.id }}
            button.auth-detail-copy[type="button" aria-label="Copy ID" data-copy-value="{{ item.id }}" onclick="AdminsShow.copyDetailValue(this)"]
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-account[aria-hidden="true"]
            span.auth-detail-label Account ID
            span.auth-detail-value {{ item.accountId }}
            button.auth-detail-copy[type="button" aria-label="Copy Account ID" data-copy-value="{{ item.accountId }}" onclick="AdminsShow.copyDetailValue(this)"]
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-person[aria-hidden="true"]
            span.auth-detail-label Email
            span.auth-detail-value {{ item.email }}
            button.auth-detail-copy[type="button" aria-label="Copy Email" data-copy-value="{{ item.emailRaw }}" onclick="AdminsShow.copyDetailValue(this)"]
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-users[aria-hidden="true"]
            span.auth-detail-label Role
            span.auth-registrant-count {{ item.role }}
            span.auth-detail-spacer
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-status[aria-hidden="true"]
            span.auth-detail-label Status
            span[class="auth-status-badge {{ item.statusClass }}"] {{ item.status }}
            span.auth-detail-spacer
        .auth-detail-column
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-status[aria-hidden="true"]
            span.auth-detail-label Verified At
            span.auth-detail-value {{ item.verifiedAt }}
            span.auth-detail-spacer
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-calendar[aria-hidden="true"]
            span.auth-detail-label Created At
            span.auth-detail-value {{ item.createdAt }}
            span.auth-detail-spacer
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-calendar[aria-hidden="true"]
            span.auth-detail-label Updated At
            span.auth-detail-value {{ item.updatedAt }}
            span.auth-detail-spacer
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-person[aria-hidden="true"]
            span.auth-detail-label Created By
            span.auth-detail-value {{ item.createdBy }}
            button.auth-detail-copy[type="button" aria-label="Copy Created By" data-copy-value="{{ item.createdBy }}" onclick="AdminsShow.copyDetailValue(this)"]
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-person[aria-hidden="true"]
            span.auth-detail-label Updated By
            span.auth-detail-value {{ item.updatedBy }}
            button.auth-detail-copy[type="button" aria-label="Copy Updated By" data-copy-value="{{ item.updatedBy }}" onclick="AdminsShow.copyDetailValue(this)"]
  `;
}

export class AdminsShow extends ShowPage {
  static css = `
    ${AuthShow.css}

    #admin-details {margin: 0;}

    .admin-overview-thumbnail {
      background-color: #f0eeff;
      color: #746de2;
    }

    .admin-overview-person {
      width: 52px;
      height: 52px;
      background: center / 52px 52px no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52' fill='none'%3E%3Ccircle cx='26' cy='18' r='10' stroke='%23746de2' stroke-width='2.6'/%3E%3Cpath d='M9 45c1-11 6.7-16.5 17-16.5S42 34 43 45' stroke='%23746de2' stroke-width='2.6' stroke-linecap='round'/%3E%3C/svg%3E");
    }

    .admin-overview-role:hover {text-decoration: none;}

    .auth-status-invited {background: #fff4d8;color: #8b6417;}
    .auth-status-suspended {background: #f2e8e7;color: #99463d;}

    .auth-detail-icon-status {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'%3E%3Ccircle cx='8' cy='8' r='5.5' stroke='%232563eb'/%3E%3Cpath d='m5.2 8 1.8 1.8 3.8-4' stroke='%232563eb' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

    .admin-action-mail-icon {
      width: 14px;
      height: 14px;
      flex: 0 0 14px;
      background: center / 14px 12px no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 12' fill='none'%3E%3Crect x='.75' y='.75' width='12.5' height='10.5' rx='1.5' stroke='white' stroke-width='1.2'/%3E%3Cpath d='m1.5 2 5.5 4.2L12.5 2' stroke='white' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

    .verification-status {
      display: block;
      padding-top: 6px;
      font-size: 11px;
      white-space: nowrap;
    }

    @media (max-width: 650px) {
      .admin-overview-person {width: 42px;height: 42px;background-size: 42px 42px;}
    }
  `;

  static timl = `
    header.auth-show-header
      h1
        a[href="/admins"] Admins
        span.auth-show-separator >
        strong#name
          span.loading-ellipse
      .auth-show-actions
        form#admin-verification-form.auth-show-regenerate-form.external-auth-form[method="POST" action="${AppConfig.authServiceApiBaseUrl}/{{ Translations.langCode }}/1/resend-email-verification" handler="AdminsShow.resendVerificationHandler" style="display:none;"]
          input#admin-verification-email[type="hidden" name="email"]
          button.auth-show-action.auth-show-action-primary[type="submit"]
            span.admin-action-mail-icon[aria-hidden="true"]
            span Resend Verification
        a#share-button.auth-show-action.auth-show-action-secondary[href="/admins/{{ Routing.params.id }}/edit"]
          span.auth-action-edit-icon[aria-hidden="true"]
          span Edit
    .auth-tabs
      button.auth-tab-button.active[type="button"] Details
    div.auth-tab-panel[data-tab-panel="details"]
      div#admin-details Loading...
  `;

  static mapItemToViewModel(item) {
    const statusValue = String(item.status || (item.verifiedAt ? 'active' : 'invited'));
    const status = statusValue.charAt(0).toUpperCase() + statusValue.slice(1).toLowerCase();
    const statusClass = `auth-status-${statusValue.toLowerCase().replace(/[^a-z0-9-]/g, '')}`;
    const roleValue = String(item.role || 'admin');
    const role = roleValue.charAt(0).toUpperCase() + roleValue.slice(1).toLowerCase();

    return {
      item: {
        id: item.id || '—',
        accountId: item.accountId || '—',
        email: item.email || '—',
        emailRaw: item.email || '',
        role,
        status,
        statusClass,
        verificationStatus: item.verifiedAt ? 'Verified' : 'Pending',
        verifiedAt: item.verifiedAt ? Util.formatDate(item.verifiedAt) : 'Pending',
        createdDate: AuthShow.formatOverviewDate(item.createdAt),
        createdAt: Util.formatDate(item.createdAt) || '—',
        createdBy: item.createdBy || '—',
        updatedAt: Util.formatDate(item.updatedAt) || '—',
        updatedBy: item.updatedBy || '—'
      }
    };
  }

  static async copyDetailValue(buttonEl) {
    return AuthShow.copyDetailValue(buttonEl);
  }

  static renderAdmin(item) {
    const viewModel = this.mapItemToViewModel(item);
    document.querySelector('#name').innerText = viewModel.item.email;
    TIML.renderInto(document.querySelector('#admin-details'), AdminDetails, viewModel);

    const verificationForm = document.querySelector('#admin-verification-form');
    const verificationEmail = document.querySelector('#admin-verification-email');
    if (verificationEmail) verificationEmail.value = viewModel.item.emailRaw;
    if (verificationForm && viewModel.item.emailRaw) {
      verificationForm.style.display = '';
    }
  }

  static javascript() {
    super.javascript();

    API.get(API.resourceUrl('admins', Routing.params.id))
      .then(data => this.renderAdmin(data.data));
  }

  static resendVerificationHandler(form, data) {
    TIML.remove('.verification-status');

    const message = data.success
      ? 'Verification email sent.'
      : 'Unable to send verification email.';

    const color = data.success ? '#2f6f3e' : '#b42318';
    form.insertAdjacentHTML('beforeend', `<small class="verification-status" style="color:${color};">${message}</small>`);
  }
}

globalThis.AdminsShow = AdminsShow;
